/**
 * 应用中心智活动模块
 */
export const ApplyLuckyDrawArr = [
  {
    path: "luckyDraw/:id(\\d+)",
    name: "luckyDraw",
    meta: {
      title: "智活动"
    },
    redirect: "/apply/luckyDraw/:id(\\d+)/turntableList",
    component: () => import("@/views/apply/luckyDraw/index.vue"),
    children: [
      {
        path: "turntableList",
        name: "turntableList",
        meta: {
          title: "大转盘"
        },
        component: () => import("@/views/apply/luckyDraw/turntableList.vue")
      },
      {
        path: "addTurntable",
        name: "addTurntable",
        meta: {
          title: "添加活动"
        },
        component: () => import("@/views/apply/luckyDraw/addTurntable.vue")
      },
      {
        path: "orderRecord",
        name: "orderRecord",
        meta: {
          title: "兑换记录"
        },
        component: () => import("@/views/apply/luckyDraw/orderRecord.vue")
      },
      {
        path: "articleManage",
        name: "articleManage",
        meta: {
          title: "文章管理"
        },
        component: () => import("@/views/apply/newVip/articleManage.vue")
      },
      {
        path: "appointManage",
        name: "appointManage",
        meta: {
          title: "预约管理"
        },
        component: () => import("@/views/apply/vip/appointManage.vue")
      },
      {
        path: "byManagement",
        name: "byManagement",
        meta: {
          title: "轮播管理"
        },
        component: () => import("@/views/apply/luckyDraw/byManagement.vue")
      }
    ]
  }
];
